define('AwaLabs.Header', [
    'Profile.Model',
    'Header.Menu.View',
    'Item.Collection',
    'SC.Configuration',
    'Profile.Model',
    'underscore',
    'LoyaltyPrice.Helper'
], function AwaLabsHeader(
    Profile,
    HeaderMenuView,
    ItemCollection,
    Configuration,
    ProfileModel,
    _,
    LoyaltyPriceHelper
) {
    'use strict';


    _.extend(HeaderMenuView.prototype, {
        getContext: _.wrap(HeaderMenuView.prototype.getContext, function getContext(fn) {
            var context = fn.apply(this, _.toArray(arguments).slice(1));
            context.categories = this.categories;
            context.dynamicMenu = this.dynamicMenu;
            return context;
        }),
        initialize: _.wrap(HeaderMenuView.prototype.initialize, function initialize(fn) {
            fn.apply(this, _.toArray(arguments).slice(1));
            this.categories = Configuration.navigationData;
            this.dynamicMenu = this.loadDynamicMenu();
            this.store = Profile.getInstance().get('store');
        }),
        render: _.wrap(HeaderMenuView.prototype.render, function render(fn) {
            if (this.doRender) {
                return fn.apply(this, _.toArray(arguments).slice(1));
            }
        }),

        loadMenu: function loadMenu(featuredItems, collection) {
            var self = this;
            var dynamicMenu = [];
            var categories = [];
            var menuFacets = Configuration.get('menuFacets', []);
            var menuFacetsValues = Configuration.get('menuFacetsValues', []);
            var menuLinks = Configuration.get('menuLinks', []);
            var profile = ProfileModel.getInstance();
            if (self.categories && self.categories.length > 0) {
                _.each(self.categories, function eachCategory(category) {
                    var featuredItem;
                    var item;
                    var menu;
                    var storeId = self.store && self.store.get('internalid');
                    if (category['data-type'] === 'commercecategory') {
                        menu = category;
                        featuredItem = _.filter(featuredItems, function filterItems(fItem) {
                            return fItem.category === category.text && fItem.storeId === String(storeId);
                        });
                        item = featuredItem && featuredItem[0] &&
                            featuredItem[0].itemId && collection.findWhere({ internalid: parseInt(featuredItem[0].itemId, 10) });
                        if (item) {
                            menu.showMenu = true;
                            menu.item = {
                                internalid: item.get('internalid'),
                                image: item.get('_thumbnail'),
                                name: item.get('_name'),
                                urlc: item.get('_url'),
                                comparePrices: item.get('_price') < item.get('_comparePriceAgainst'),
                                customerPrice: item.get('_price_formatted'),
                                loyaltyPrice: item.get('custitem_aws_loyaltyprice_stored'),
                                loyaltyItem: item.get('custitemaws_loyalty_item_checkbox'),
                                basePrice: _.formatCurrency(item.get('_comparePriceAgainst')),
                                priceRange: item.get('onlinematrixpricerange') ? item.getPriceRange() : null,
                                customContext: LoyaltyPriceHelper.getContextForPriceView(item.toJSON(), profile)
                            };
                        }
                        if (menuFacets && menuFacets.length > 0) {
                            menu.facets = [];
                            _.each(menuFacets, function eachMenuFacets(facet) {
                                if (facet.category === category.text && menuFacetsValues && menuFacetsValues.length > 0) {
                                    facet.values = _.filter(menuFacetsValues, function filterFacetValues(facetValue) {
                                        return facetValue.menuFacetId === facet.id;
                                    });
                                    if (facet.values && facet.values.length > 0) {
                                        menu.showMenu = true;
                                        menu.facets.push(facet);
                                    }
                                }
                            });
                        }
                        if (menuLinks && menuLinks.length > 0) {
                            menu.links = _.filter(menuLinks, function filterLinks(link) {
                                return category.text === link.category;
                            }) || [];
                            if (menu.links && menu.links.length > 0) {
                                menu.showMenu = true;
                            }
                        }
                    } else if (category.allStore || category.storeId === String(storeId)) {
                        self.replaceLinkByConfiguration(category);
                        categories.push(category);
                    }
                    if (menu) {
                        self.replaceLinkByConfiguration(menu);
                        menu.hasFacetsOrSubCategories = (menu.categories && menu.categories.length > 0) || (menu.facets && menu.facets.length > 0);
                        dynamicMenu.push(menu);
                    }
                });
            }
            self.dynamicMenu = dynamicMenu;
            self.categories = categories;
            self.doRender = true;
            self.render();
        },
        replaceLinkByConfiguration: function replaceLinkByConfiguration(element) {
            var config = _.findWhere(Configuration.get('categoryLinks', []), { categoryUrl: element.href });
            if (config) {
                element.href = config.categoryNewUrl;
                element.data.hashtag = config.categoryNewUrl;
                element.isBlankCategory = config.isBlank;
                element.isAbsolute = config.isAbsolute;
                element.previusHref = config.categoryUrl;
            } else {
                element.isBlankCategory = false;
                element.isAbsolute = false;
            }
        },
        loadDynamicMenu: function loadDynamicMenu() {
            var self = this;
            var promise;
            var collection = new ItemCollection();
            var featuredItems = Configuration.get('featuredItems', []);
            var menuFacets = Configuration.get('menuFacets', []);
            var profile = ProfileModel.getInstance();
            var store = profile.get('store');
            var pricelevel = profile.get('priceLevel');
            var defaultPricelevel = SC.ENVIRONMENT.siteSettings.defaultpricelevel;
            var itemIds = _.compact(
                _.map(featuredItems, function eachItem(item) {
                    return item && item.itemId && parseInt(item.itemId, 10);
                })
            ).join(',');

            if (menuFacets && menuFacets.length) {
                _.each(menuFacets, function eachMenuFacet(menuFacet) {
                    if (menuFacet.facetId && menuFacet.facetId.indexOf('pricelevel') === 0 && store && store.get('priceField')) {
                        if (pricelevel !== defaultPricelevel) {
                            menuFacet.facetId = 'pricelevel' + pricelevel;
                        } else {
                            menuFacet.facetId = store.get('priceField').toLowerCase();
                        }
                    }
                });
            }
            if (itemIds) {
                promise = collection.fetch({
                    data: {
                        id: itemIds,
                        fieldset: 'dynamicitems'
                    },
                    preventDefault: true
                });

                promise.success(function success() {
                    self.loadMenu(featuredItems, collection);
                });
                promise.fail(function onFail() {
                    self.loadMenu([], collection);
                });
            }
        }
    });

    return {
        mountToApp: function mountToApp(container) {
            var layout = container.getComponent('Layout');
            var profileStore = ProfileModel.getInstance();
            var store = (profileStore && profileStore.get && profileStore.get('store') && profileStore.get('store').get && profileStore.get('store').get('internalid')) || '';
            var self = this;
            this.storeSelected = _.find(Configuration.get('storeLinks'), function findStore(s) {
                return s.storeId === store.toString();
            });
            if (layout) {
                if (!self.storeSelected) {
                    return;
                }
                layout.addToViewContextDefinition('Header.Menu.View', 'storeURL', 'string', function fn() {
                    return self.storeSelected && self.storeSelected.linkUrl;
                });
                layout.addToViewContextDefinition('Header.Menu.View', 'storeText', 'string', function fn() {
                    return self.storeSelected && self.storeSelected.linkText;
                });
                layout.addToViewContextDefinition('Header.View', 'storeURL', 'string', function fn() {
                    return self.storeSelected && self.storeSelected.linkUrl;
                });
                layout.addToViewContextDefinition('Header.View', 'storeText', 'string', function fn() {
                    return self.storeSelected && self.storeSelected.linkText;
                });
            }
        }
    };
});
